<template>
  <b-dd
    id="f-i18n"
    ref="f-i18n"
    right
    variant="outline-secondary"
    :title="$t('nav.langChange', '-t')"
  >
    <template v-slot:button-content>
      <i class="fas fa-language fa-lg"></i>
      <span
        class="sr-only"
        v-html="$t('nav.lang', '-t')"
      ></span>
    </template>
    <li
      v-for="lang in translations.available"
      :key="lang"
      role="presentation"
    >
      <b-link
        :to="`/${lang}/${($route.path.split('/')[2] || '')}`"
        class="dropdown-item"
        role="menuitem"
        @click.native="changeLanguage(lang)"
        v-text="translations[lang]"
      />
    </li>
    <b-dd-divider v-if="$t('config.translations.translate') !== ''" />
    <li 
      v-if="$t('config.translations.translate') !== ''"
      role="presentation"
    >
      <a
        :href="$t('config.translations.translate')"
        class="dropdown-item"
        role="menuitem"
      >
        <i class="fas fa-plus"></i>
        <span v-html="$t('nav.translate')"></span>
      </a>
    </li>
  </b-dd>
</template>

<script>
export default {
  data() {
    return {
      currentComponent: '',
      translations: this.$i18n.messages.translations,
    };
  },

  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      [this.currentComponent] = [this.$route.path.split('/')[2]];
      this.$refs['f-i18n'].hide(true);
    },
  },
};
</script>

<style lang="scss">
#f-i18n {
  button {
    color: var(--f-secondary);
    border: none;

    &:hover {
      color: var(--f-light);
    }
  }

  &.show button i::before {
    color: var(--f-light);
  }

  li a {
    background: transparent;

    &:hover, &:focus {
      background-color: var(--f-light);
    }
  }
}
</style>
